import { useEffect, useRef, useState } from "react"

export default function Dropdown({
  value = 'Dropdown',
  setValue = undefined,
  options = [],
  addClass, addStyle
}) {
  const [open, setOpen] = useState(false)
  const refDropdown = useRef()

  useEffect(() => {
    if (open) {
      document.onclick = (e) => {
        e.target !== refDropdown.current && setOpen(false)
      }
    }
  }, [open])

  return (
    <div className={`dropdown ${addClass}`} style={addStyle}>
      <button ref={refDropdown} className={`selected ${open && 'open'}`} onClick={() => setOpen(!open)}>
        {value}
        <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.999999 1.5L5 5.5L9 1.5" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      <div className={`dropdown-content fade ${open && 'active'}`}>
        {
          options.map((item, i) => {
            let styleComp
            i === 0 && (styleComp = { borderRadius: '16px 16px 0 0' })
            i + 1 === options.length && (styleComp = { borderRadius: '0 0 16px 16px' })
            return (
              <button key={i} onClick={() => setValue(item)} style={styleComp}>{item}</button>
            )
          })
        }
      </div>
    </div>
  )
}
